// RowHeaderButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './RowHeaderButton.css';

// Icons
import Icon from 'svg/Icon';

/**
 * RowHeaderButton
 * 
 * Renders a button in the row header.
 * 
 * @param {ReactComponent} icon - Icon to render in the button.
 * @param {string} iconKey - Icon key to render via Icon.
 * @param {Function} onClick - Callback when button is clicked.
 *  
 *
 * @returns {ReactNode} - RowHeaderButton.
 */
const RowHeaderButton = React.memo(({ icon: IconComponent, iconKey, title = '', onClick }) => {

    // ----- CONTEXT ----- //

    // Theme Context

    const { theme } = useTheme();

    // ----- STATE ----- //

    // Hover State

    const [hovered, setHovered] = useState(false);
    const hasIcon = !!iconKey || !!IconComponent;
    if (!hasIcon) return null;

    // ----- RENDER ----- //

    return (

        <div
          className="row-header-button-container"
          title={title}
          onClick={onClick}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
            {iconKey ? (
                <Icon
                  iconKey={iconKey}
                  color={hovered ? theme.foreground : theme.foregroundMuted}
                  width={18}
                  height={18}
                />
            ) : (
                <IconComponent
                  color={hovered ? theme.foreground : theme.foregroundMuted}
                  width={18}
                  height={18}
                />
            )}
        </div>
    );

});

// Dev Tools
RowHeaderButton.displayName = 'RowHeaderButton';

export default RowHeaderButton;
